import { AiOutlineClose } from "react-icons/ai";
import useAlgoliaSorting from "@/hooks/algolia/useAlgoliaSorting";

function ResponsiveSort({
  setOpenSortBox,
  t,
  setCurrentRefinement,
  currentRefinement,
}) {
  const { optionsData, handleSelection } = useAlgoliaSorting(
    t,
    currentRefinement,
    setCurrentRefinement
  );

  return (
    <div className="fixed top-10 left-0 z-50 flex items-center justify-center w-screen h-screen bg-lightblack">
      <div className="w-[570px] max-[570px]:w-[98%] mx-auto bg-white p-2 rounded-md">
        <div className="flex items-center justify-between pb-1 border-b">
          <h1 className="mb-3 text-lg font-semibold text-red">{t("SortBy")}</h1>
          <AiOutlineClose
            onClick={() => setOpenSortBox(false)}
            size="20px"
            className="cursor-pointer text-red"
          />
        </div>
        <ul>
          {optionsData?.map((item) => (
            <li
              onClick={() => handleSelection(item?.value)}
              key={item?.value}
              className="flex items-center py-2 mb-2 border-b last:border-b-0 last:mb-0"
            >
              <div className="relative w-5 h-5 bg-white border rounded-full">
                {item?.value === currentRefinement && (
                  <div className="absolute w-3 h-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue top-1/2 left-1/2"></div>
                )}
              </div>
              <h5 className="mx-2"> {t(item?.label)}</h5>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ResponsiveSort;
